// extracted by mini-css-extract-plugin
module.exports = {"setting":"index_setting_2v6vv","title":"index_title_2_gWy","form":"index_form_13XPO"};